interface CreditPackageCandidate {
  id: string;
  amount: number;
  disabled?: boolean;
}

export function getRecommendedCreditPackage<T extends CreditPackageCandidate>(
  packages: T[],
  {
    actionCost,
    balance,
    intendedRuns = 3,
  }: {
    actionCost: number;
    balance: number;
    intendedRuns?: number;
  }
): T | undefined {
  const enabledPackages = packages
    .filter((item) => !item.disabled)
    .sort((a, b) => a.amount - b.amount);
  if (enabledPackages.length === 0) return undefined;

  const targetCredits = Math.max(
    1,
    actionCost * Math.max(1, intendedRuns) - Math.max(0, balance)
  );
  return (
    enabledPackages.find((item) => item.amount >= targetCredits) ??
    enabledPackages.at(-1)
  );
}

export function normalizeLocalReturnPath(value: unknown) {
  if (typeof value !== 'string' || !/^\/(?!\/)/.test(value)) {
    return undefined;
  }
  try {
    const parsed = new URL(value, 'https://local.invalid');
    if (parsed.origin !== 'https://local.invalid') return undefined;
    return `${parsed.pathname}${parsed.search}${parsed.hash}`;
  } catch {
    return undefined;
  }
}

export function buildCreditCheckoutReturnUrls({
  baseUrl,
  isCreem,
  returnTo,
}: {
  baseUrl: string;
  isCreem: boolean;
  returnTo: string;
}) {
  const safeReturnTo =
    normalizeLocalReturnPath(returnTo) ?? '/settings/credits';
  const cancelUrl = `${baseUrl}${safeReturnTo}`;
  const successUrl = isCreem
    ? cancelUrl
    : `${baseUrl}/settings/payment?session_id={CHECKOUT_SESSION_ID}&callback=${encodeURIComponent(safeReturnTo)}`;
  return { cancelUrl, successUrl };
}
